/* =========================================================
   CSTM BUILDER - SHARED LOGIC v3-updated-steps
   ========================================================= */
(function(){
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init(){
    const builderRoot = document.getElementById('cstmBuilderRoot');
    const barRoot = document.getElementById('cstmBar');
    if (!barRoot && !builderRoot) return;

    const CONFIG = Object.assign({
      fixedAdditivesPerPot: 18,
      potGrams: 300,
      maxScoop: 999,
      visualMax: 30,
      cartUrl: "/cart",
      addUrl: "/cart/add.js",
      variants: { tropical: 0, framboos: 0 }
    }, window.CSTM_CONFIG || {});

    const groups = {
      "Energie & Focus":            ["Caf\u00e9\u00efne", "Tyrosine", "Acetyl L-Carnitine"],
      "Pomp & Uithoudingsvermogen": ["L-Citrulline", "Glycerol", "Beta Alanine", "L-Arginine"],
      "Herstel & Hydratatie":       ["Taurine", "Glycine", "Magnesium", "Elektrolyten"],
      "Opname & Effect":            ["Piperine"]
    };

    const ingredients = {
      "Caf\u00e9\u00efne": {
        steps: [0, 0.1, 0.2, 0.3, 0.35, 0.4],
        unit: "g", note: "max 400mg",
        info: "Boost je focus, kracht en uithoudingsvermogen. \uD83D\uDD25",
        warn: "Kan rusteloosheid of slaapproblemen veroorzaken."
      },
      "Tyrosine": {
        steps: [0, 0.5, 1.0, 1.5, 2.0, 2.5],
        unit: "g", note: "focus",
        info: "Verbetert focus, alertheid en stressbestendigheid. \uD83E\uDDE0",
        warn: "Bij hoge dosering soms lichte hoofdpijn of spanningsgevoel."
      },
      "Acetyl L-Carnitine": {
        steps: [0, 0.25, 0.5, 0.75, 1.0, 1.5, 2.0],
        unit: "g", note: "focus",
        info: "Voor mentale scherpte en vetverbranding. \u26A1",
        warn: "Kan bij hoge dosering lichte nervositeit veroorzaken."
      },
      "L-Citrulline": {
        steps: [0, 2, 3, 4, 5, 6, 7, 8],
        unit: "g", note: "pomp",
        info: "Stimuleert bloedtoevoer, pomp en uithoudingsvermogen. \uD83D\uDCAA",
        warn: "Kan bij hoge dosering zorgen voor maagklachten."
      },
      "Glycerol": {
        steps: [0, 1.5, 3.0],
        unit: "g", note: "hydratatie pomp",
        info: "Ondersteunt hydratatie en spiervolheid tijdens de training. \uD83D\uDCA7",
        warn: "Hoge doseringen vragen om extra waterinname."
      },
      "Beta Alanine": {
        steps: [0, 1, 2, 3.2, 4, 5],
        unit: "g", note: "uithouding",
        info: "Verhoogt je uithoudingsvermogen en spierbuffering. \uD83D\uDCA5",
        warn: "Kan tijdelijke tintelingen veroorzaken (paresthesie)."
      },
      "L-Arginine": {
        steps: [0, 1, 2, 3, 4],
        unit: "g", note: "NO-boost",
        info: "Bevordert pomp en doorbloeding tijdens je training. \uD83D\uDD04",
        warn: "Kan bij sommige mensen maag- of darmklachten veroorzaken."
      },
      "Taurine": {
        steps: [0, 0.5, 1.0, 1.5, 2.0, 2.5, 3.0],
        unit: "g", note: "herstel",
        info: "Ondersteunt hydratatie, spierfunctie en focus. \uD83D\uDCA7",
        warn: "Zelden bijwerkingen, maar hoge dosering kan slaperigheid geven."
      },
      "Glycine": {
        steps: [0, 0.5, 1, 1.5, 2, 3],
        unit: "g", note: "herstel",
        info: "Bevordert herstel, focus en spierco\u00f6rdinatie. \uD83E\uDDEC",
        warn: "Hoge doseringen kunnen lichte slaperigheid veroorzaken."
      },
      "Magnesium": {
        steps: [0, 0.1, 0.2, 0.3, 0.4],
        unit: "g", note: "spierfunctie",
        info: "Ondersteunt spierfunctie, hydratatie en zenuwgeleiding. \u2699\uFE0F",
        warn: "Te veel kan laxerend werken of lichte maagklachten geven."
      },
      "Elektrolyten": {
        steps: [0, 1.0, 2.0],
        unit: "g", note: "hydratatie",
        info: "Zorgen voor optimale hydratatie en spierfunctie. \uD83D\uDCA6",
        warn: "Bij hoge dosering soms lichte maagklachten of zout nasmaak."
      },
      "Piperine": {
        steps: [0, 0.005],
        unit: "g", note: "zwarte peper extract", displayUnit: "mg",
        info: "Piperine 95% (Zwarte Peper extract): Ondersteunt de opname en effectiviteit van de blend."
      }
    };
    Object.keys(ingredients).forEach(k => ingredients[k].value = 0);

    const presets = {
      nrg: [
        ["Caf\u00e9\u00efne", 0.3], ["Tyrosine", 2.0], ["Acetyl L-Carnitine", 1.0],
        ["Beta Alanine", 2], ["Taurine", 2.0], ["L-Citrulline", 5],
        ["Glycine", 1], ["L-Arginine", 1], ["Piperine", 0.005]
      ],
      mxpmp: [
        ["L-Citrulline", 8], ["L-Arginine", 4], ["Glycerol", 3.0],
        ["Beta Alanine", 3.2], ["Taurine", 2.0], ["Glycine", 1.5],
        ["Elektrolyten", 1.0], ["Piperine", 0.005]
      ],
      stmn8: [
        ["Beta Alanine", 3.2], ["L-Citrulline", 6], ["Taurine", 2.0],
        ["Glycine", 2.0], ["Elektrolyten", 2.0], ["Tyrosine", 1.5],
        ["Caf\u00e9\u00efne", 0.2], ["Piperine", 0.005]
      ]
    };

    let selectedFlavor = null;
    let warnTimer;

    function cssId(name){ return name.replace(/[^a-zA-Z0-9]/g, "_"); }
    function customRound(num){
      const third = Math.floor(num * 1000) % 10;
      return third >= 5 ? Math.ceil(num) : Math.floor(num);
    }
    function formatStepLabel(s, ing){
      if (ing.displayUnit === "mg") return Math.round(s * 1000);
      return s;
    }
    function isMobile(){ return window.matchMedia('(max-width: 600px)').matches; }

    function ensureInfoModal(){
      if (document.getElementById('cstmInfoModal')) return;
      const css = document.createElement('style');
      css.id = 'cstmInfoModalCss';
      css.textContent = `
        #cstmInfoOverlay{ position:fixed;inset:0;background:rgba(0,0,0,0.55);opacity:0;pointer-events:none;transition:opacity .2s ease;z-index:999998;backdrop-filter:blur(2px); }
        #cstmInfoOverlay.show{ opacity:1;pointer-events:auto; }
        #cstmInfoModal{ position:fixed;left:50%;top:50%;transform:translate(-50%,-50%) scale(0.95);width:calc(100vw - 40px);max-width:380px;background:#111111;color:#fff;padding:22px 22px 18px;font-family:'Archivo',sans-serif;font-size:14px;line-height:1.5;opacity:0;pointer-events:none;transition:opacity .2s ease,transform .2s ease;z-index:999999;box-shadow:0 20px 60px rgba(0,0,0,0.4);max-height:80vh;overflow-y:auto; }
        #cstmInfoModal.show{ opacity:1;pointer-events:auto;transform:translate(-50%,-50%) scale(1); }
        #cstmInfoModal .cstm-info-title{ font-family:'Archivo Black',sans-serif;text-transform:uppercase;font-size:13px;letter-spacing:0.06em;color:#F44611;margin:0 0 12px;padding-right:30px; }
        #cstmInfoModal .cstm-info-body{ margin:0; }
        #cstmInfoModal .cstm-info-warn{ display:block;margin-top:14px;padding-top:12px;border-top:1px solid rgba(255,255,255,0.15);font-size:13px;color:#ffb89e; }
        #cstmInfoClose{ position:absolute;top:12px;right:12px;width:32px;height:32px;border:0;background:transparent;color:#fff;font-size:22px;line-height:1;cursor:pointer;padding:0;display:flex;align-items:center;justify-content:center;border-radius:50%;transition:background .15s ease; }
        #cstmInfoClose:hover{ background:rgba(255,255,255,0.1); }
      `;
      document.head.appendChild(css);
      const overlay = document.createElement('div');
      overlay.id = 'cstmInfoOverlay';
      document.body.appendChild(overlay);
      const modal = document.createElement('div');
      modal.id = 'cstmInfoModal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.innerHTML = `<button id="cstmInfoClose" type="button" aria-label="Sluiten">\u00d7</button><h4 class="cstm-info-title" id="cstmInfoTitle"></h4><p class="cstm-info-body" id="cstmInfoBody"></p>`;
      document.body.appendChild(modal);
      overlay.addEventListener('click', closeInfoModal);
      document.getElementById('cstmInfoClose').addEventListener('click', closeInfoModal);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeInfoModal(); });
    }

    function openInfoModal(name){
      ensureInfoModal();
      const ing = ingredients[name];
      if (!ing || !ing.info) return;
      const overlay = document.getElementById('cstmInfoOverlay');
      const modal = document.getElementById('cstmInfoModal');
      const title = document.getElementById('cstmInfoTitle');
      const body = document.getElementById('cstmInfoBody');
      title.textContent = name;
      let html = ing.info;
      if (ing.warn) html += `<span class="cstm-info-warn"><strong>Let op:</strong> ${ing.warn}</span>`;
      body.innerHTML = html;
      overlay.classList.add('show');
      modal.classList.add('show');
      document.body.style.overflow = 'hidden';
    }

    function closeInfoModal(){
      const overlay = document.getElementById('cstmInfoOverlay');
      const modal = document.getElementById('cstmInfoModal');
      if (overlay) overlay.classList.remove('show');
      if (modal) modal.classList.remove('show');
      document.body.style.overflow = '';
    }

    function buildSliders(){
      if (!builderRoot) return;
      const groupsDiv = document.getElementById('cstmGroups');
      if (!groupsDiv) return;
      groupsDiv.innerHTML = "";
      Object.entries(groups).forEach(([title, list])=>{
        const sec = document.createElement("section");
        sec.className = "group";
        sec.innerHTML = `<h3>${title}</h3>`;
        list.forEach(name=>{
          const ing = ingredients[name];
          const row = document.createElement("div");
          row.className = "ing";
          let infoBtnHtml = "";
          if (ing.info){
            const warnHtml = ing.warn ? `<span class="warn-line"><strong>Let op:</strong> ${ing.warn}</span>` : "";
            infoBtnHtml = `<span class="info-wrap"><button type="button" class="info-btn" aria-label="Info over ${name}" data-ing-name="${encodeURIComponent(name)}">i</button><div class="tooltip tooltip-desktop">${ing.info}${warnHtml}</div></span>`;
          }
          const dispUnit = ing.displayUnit || ing.unit;
          row.innerHTML = `
            <div>
              <div class="name">${name} ${infoBtnHtml}</div>
              <div class="info">${ing.note}</div>
            </div>
            <div class="val zero" id="val-${cssId(name)}">0<small style="font-size:11px;color:#999"> ${dispUnit}</small></div>
            <div class="slider-row">
              <input type="range" min="0" max="${ing.steps.length-1}" step="1" value="0" id="sl-${cssId(name)}" data-name="${name}">
              <div class="steps">${ing.steps.map(s => `<span>${formatStepLabel(s, ing)}</span>`).join("")}</div>
            </div>
          `;
          sec.appendChild(row);
        });
        groupsDiv.appendChild(sec);
      });

      builderRoot.querySelectorAll('input[type=range]').forEach(s=>{ s.addEventListener("input", onSlider); paintTrack(s); });

      builderRoot.querySelectorAll(".info-btn").forEach(btn=>{
        btn.addEventListener("click", (e)=>{
          e.stopPropagation(); e.preventDefault();
          const name = decodeURIComponent(btn.dataset.ingName);
          if (isMobile()){
            openInfoModal(name);
          } else {
            const wrap = btn.closest('.info-wrap');
            const tip = wrap ? wrap.querySelector('.tooltip-desktop') : null;
            const wasOpen = btn.classList.contains('open');
            builderRoot.querySelectorAll('.tooltip-desktop.open').forEach(t => t.classList.remove('open'));
            builderRoot.querySelectorAll('.info-btn.open').forEach(b => b.classList.remove('open'));
            if (!wasOpen){ btn.classList.add('open'); if (tip) tip.classList.add('open'); }
          }
        });
      });

      document.addEventListener("click", (e)=>{
        if (e.target.closest('.tooltip-desktop') || e.target.closest('.info-btn')) return;
        builderRoot.querySelectorAll(".tooltip-desktop.open").forEach(t => t.classList.remove("open"));
        builderRoot.querySelectorAll(".info-btn.open").forEach(b => b.classList.remove("open"));
      });

      builderRoot.querySelectorAll(".preset").forEach(b => { b.addEventListener("click", ()=> applyPreset(b.dataset.preset)); });

      builderRoot.querySelectorAll(".flavor").forEach(btn => {
        btn.addEventListener("click", ()=>{
          selectedFlavor = btn.dataset.flavor;
          builderRoot.querySelectorAll(".flavor").forEach(b => b.classList.toggle("active", b === btn));
          updateAll();
        });
      });
    }

    function paintTrack(slider){
      const max = parseInt(slider.max,10);
      const v = parseInt(slider.value,10);
      const pct = max === 0 ? 0 : (v/max)*100;
      const root = slider.closest('.cstm-builder');
      const trackColor = root ? getComputedStyle(root).getPropertyValue('--track') || '#E6E1DC' : '#E6E1DC';
      slider.style.background = `linear-gradient(to right, #F44611 0 ${pct}%, ${trackColor.trim()} ${pct}% 100%)`;
    }

    function onSlider(e){
      const name = e.target.dataset.name;
      const idx = parseInt(e.target.value,10);
      const desired = ingredients[name].steps[idx];
      const otherSum = Object.entries(ingredients).reduce((s,[k,v]) => s + (k===name ? 0 : v.value), 0);
      const space = CONFIG.maxScoop - otherSum;
      if (desired > space + 0.0001){
        const allowed = ingredients[name].steps.filter(x => x <= space + 0.0001);
        const max = allowed.length ? allowed[allowed.length-1] : 0;
        const newIdx = ingredients[name].steps.indexOf(max);
        e.target.value = newIdx;
        ingredients[name].value = max;
        showWarn();
      } else {
        ingredients[name].value = desired;
      }
      const valEl = document.getElementById(`val-${cssId(name)}`);
      if (valEl){
        const ing = ingredients[name];
        const v = ingredients[name].value;
        if (ing.displayUnit === "mg"){
          valEl.innerHTML = `${Math.round(v * 1000)}<small style="font-size:11px;color:#999"> mg</small>`;
        } else {
          valEl.innerHTML = `${v.toFixed(v < 1 && v > 0 ? 2 : 1)}<small style="font-size:11px;color:#999"> ${ing.unit}</small>`;
        }
        valEl.classList.toggle("zero", v === 0);
      }
      paintTrack(e.target);
      clearActivePreset();
      updateAll();
    }

    function applyPreset(type){
      if (type === "reset"){ resetAll(); return; }
      resetAll(false);
      (presets[type] || []).forEach(([name,val]) => setIngredient(name, val));
      if (builderRoot) builderRoot.querySelectorAll(".preset").forEach(b => b.classList.toggle("active", b.dataset.preset === type));
    }
    function clearActivePreset(){
      if (!builderRoot) return;
      builderRoot.querySelectorAll(".preset.active").forEach(b => b.classList.remove("active"));
    }
    function setIngredient(name, target){
      const slider = document.getElementById(`sl-${cssId(name)}`);
      if (!slider){ ingredients[name].value = target; return; }
      const steps = ingredients[name].steps;
      let idx = steps.indexOf(target);
      if (idx === -1){
        let best = 0, diff = Infinity;
        steps.forEach((s,i)=>{ const d = Math.abs(s-target); if (d<diff){ diff=d; best=i; }});
        idx = best;
      }
      slider.value = idx;
      slider.dispatchEvent(new Event("input", {bubbles:true}));
    }
    function resetAll(clearActive = true){
      Object.keys(ingredients).forEach(k=>{
        ingredients[k].value = 0;
        const sl = document.getElementById(`sl-${cssId(k)}`);
        if (sl){ sl.value = 0; paintTrack(sl); }
        const v = document.getElementById(`val-${cssId(k)}`);
        if (v){
          const dispUnit = ingredients[k].displayUnit || ingredients[k].unit;
          const zero = ingredients[k].displayUnit === "mg" ? "0" : "0.0";
          v.innerHTML = `${zero}<small style="font-size:11px;color:#999"> ${dispUnit}</small>`;
          v.classList.add("zero");
        }
      });
      if (clearActive) clearActivePreset();
      updateAll();
    }

    function showWarn(){
      const w = document.getElementById("cstmWarn");
      if (!w) return;
      w.classList.add("show");
      clearTimeout(warnTimer);
      warnTimer = setTimeout(()=>w.classList.remove("show"), 1800);
    }

    function updateAll(){
      const active = Object.values(ingredients).reduce((s,v)=>s+v.value,0);
      const scoopsRounded = active > 0 ? customRound(CONFIG.potGrams / active) : 0;
      const additivesPerScoop = scoopsRounded > 0 ? CONFIG.fixedAdditivesPerPot / scoopsRounded : 0;
      const scoopSize = active === 0 ? 0 : active + additivesPerScoop;
      const scoopSizeEl = document.getElementById("cstmScoopSize");
      const scoopCountEl = document.getElementById("cstmScoopCount");
      const scoopBarEl = document.getElementById("cstmScoopBar");
      const orderBtn = document.getElementById("cstmOrderBtn");
      const bar = document.getElementById("cstmBar");
      if (scoopSizeEl) scoopSizeEl.textContent = scoopSize.toFixed(1);
      if (scoopCountEl) scoopCountEl.textContent = active > 0 ? scoopsRounded : "\u2014";
      if (scoopBarEl) scoopBarEl.style.width = Math.min(100, (active / CONFIG.visualMax) * 100) + "%";
      if (orderBtn){ const canOrder = active > 0 && selectedFlavor !== null; orderBtn.disabled = !canOrder; }
      if (bar){ const shouldShow = active > 0; bar.classList.toggle("visible", shouldShow); document.body.classList.toggle("cstm-bar-active", shouldShow); }
    }

    function buildCartProperties(){
      const props = {};
      const orderedNames = [];
      Object.values(groups).forEach(list => list.forEach(n => orderedNames.push(n)));
      const mixSummary = [];
      orderedNames.forEach(name => {
        const ing = ingredients[name];
        if (ing.value > 0){
          if (ing.displayUnit === "mg"){
            const mg = Math.round(ing.value * 1000);
            props[name] = `${mg} mg`;
            mixSummary.push(`${name}: ${mg}mg`);
          } else {
            const v = ing.value;
            const formatted = v < 1 ? v.toFixed(2) : v.toFixed(1);
            props[name] = `${formatted} g`;
            mixSummary.push(`${name}: ${formatted}g`);
          }
        }
      });
      const active = Object.values(ingredients).reduce((s,v)=>s+v.value,0);
      const scoopsRounded = active > 0 ? customRound(CONFIG.potGrams / active) : 0;
      const additivesPerScoop = scoopsRounded > 0 ? CONFIG.fixedAdditivesPerPot / scoopsRounded : 0;
      const scoopSize = active === 0 ? 0 : active + additivesPerScoop;
      props["_Scoopgrootte"] = scoopSize.toFixed(1) + " g";
      props["_Aantal scoops"] = String(scoopsRounded);
      props["_Mix samenstelling"] = mixSummary.join(" | ");
      return props;
    }

    function onOrderClick(){
      const orderBtn = document.getElementById("cstmOrderBtn");
      if (!orderBtn || orderBtn.disabled) return;
      if (!selectedFlavor){ showWarn(); return; }
      const variantId = CONFIG.variants[selectedFlavor];
      if (!variantId){ alert("Variant ID ontbreekt. Stel deze in via Theme Customizer."); return; }
      const originalText = orderBtn.innerHTML;
      orderBtn.disabled = true;
      orderBtn.innerHTML = '<span class="spinner"></span> Toevoegen...';
      const properties = buildCartProperties();
      const formData = { items: [{ id: variantId, quantity: 1, properties: properties }] };
      fetch(CONFIG.addUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(formData)
      })
      .then(r => { if (!r.ok) throw new Error("Cart add failed: " + r.status); return r.json(); })
      .then(() => { window.location.href = CONFIG.cartUrl; })
      .catch(err => {
        console.error("CSTM cart error:", err);
        orderBtn.innerHTML = originalText;
        orderBtn.disabled = false;
        alert("Er ging iets mis bij het toevoegen aan de winkelwagen. Probeer het opnieuw.");
      });
    }

    if (builderRoot) buildSliders();
    const orderBtn = document.getElementById("cstmOrderBtn");
    if (orderBtn) orderBtn.addEventListener("click", onOrderClick);
    updateAll();

    (function applyUrlParams(){
      const params = new URLSearchParams(window.location.search);
      const smaakParam = params.get('smaak');
      if (smaakParam && builderRoot){
        const flavorBtn = builderRoot.querySelector('.flavor[data-flavor="' + smaakParam + '"]');
        if (flavorBtn) flavorBtn.click();
      }
      const ingParam = params.get('ingredienten');
      if (ingParam && builderRoot){
        resetAll(false);
        ingParam.split(',').forEach(function(part){
          const colonIdx = part.indexOf(':');
          if (colonIdx === -1) return;
          const rawName = decodeURIComponent(part.slice(0, colonIdx));
          const val = parseFloat(part.slice(colonIdx + 1));
          if (!isNaN(val) && ingredients[rawName] !== undefined) setIngredient(rawName, val);
        });
        updateAll();
        try { const clean = window.location.pathname + window.location.hash; window.history.replaceState(null, '', clean); } catch(e){}
      }
    })();

    window.CSTMBuilder = { openInfo: openInfoModal, closeInfo: closeInfoModal, ingredients, version: "v3-updated-steps" };
  }
})();
